import './boot.css';

declare global {
	interface Window {
		forceReload: () => void;
	}
}

window.forceReload = () => {
	const delimiter = window.location.href.includes('?') ? '&' : '?';
	window.location.href = `${window.location.href + delimiter}cacheBreaker=${Math.random()}`;
};

// Add ARIA loading message
(function addAriaLoadingMessage() {
	const lng = navigator.language.slice(0, 2) || 'en';
	const i18n: Record<string, string> = {
		en: 'Loading',
		de: 'Laden',
		cs: 'Načítání',
		da: 'Indlæser',
		es: 'Cargando',
		fr: 'Chargement en cours',
		it: 'Caricamento in corso',
		nl: 'Laden',
		no: 'Laster',
		pl: 'Wgrywanie',
		pt: 'Carregando',
		ru: 'Загрузка',
		ar: 'جاري التحميل',
		zh: '正在加载',
		sv: 'Laddar',
		sk: 'Načítanie',
		fi: 'Ladataan',
	};
	const el = document.createElement('div');
	el.id = 'mx-aria-initial-loading-msg';
	el.setAttribute('role', 'alert');
	el.setAttribute('aria-live', 'assertive');
	el.setAttribute('tabindex', '-1');
	el.setAttribute('style', 'position: absolute; width: 1px; height: 1px; overflow: hidden; clip: rect(0, 0, 0, 0);');
	el.textContent = `${i18n[lng] || i18n.en}.`;
	document.body.after(el);
})();

// Checks whether the base Path equals to location.pathname with case-sensitive.
// If the register doesn't match, the base Path will be substituted by value from location.pathname as template for all relative URLs in a document.
let basePath;
const baseElement = document.getElementsByTagName('base')[0];
if (baseElement) {
	const attrHref = baseElement.attributes.getNamedItem('href');
	if (!!attrHref && !!attrHref.value && attrHref.value !== '/') {
		basePath = attrHref.value.replace(/^(https?:)?\/\/[^/]*/, '').toLowerCase();
		const pathname = window.location.pathname.toLowerCase();
		const startIndex = pathname.indexOf(basePath);
		if (startIndex !== -1) {
			attrHref.value = window.location.pathname.substring(startIndex, basePath.length);
		}
	}
}

function get_browser_info() {
	const ua = navigator.userAgent;
	let tem,
		M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
	if (/trident/i.test(M[1])) {
		tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
		return { name: 'IE', version: tem[1] || '' };
	}
	if (M[1] === 'Chrome') {
		tem = ua.match(/\bOPR\/(\d+)/);
		if (tem !== null) {
			return { name: 'Opera', version: tem[1] };
		}
	}
	M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
	if ((tem = ua.match(/version\/(\d+)/i)) !== null) {
		M.splice(1, 1, tem[1]);
	}
	return {
		name: M[0],
		version: M[1],
	};
}

const browser = get_browser_info();

// Checks the browser name and version.
// This checking should be before loading any scripts and DOM elements that could make critical changes in processing of page (e.g. redefining location).
// In case the browser is not supported we will be redirected to the proper page with an appropriate describing.
const browserIsSupported = !(
	((browser.name === 'IE' || browser.name === 'MSIE') && parseInt(browser.version, 10) <= 11) ||
	(browser.name === 'Safari' && parseInt(browser.version, 10) <= 5)
);

if (!browserIsSupported) {
	window.location.href = window.location.origin + (basePath || '/') + 'unsupported-browser.html';
}

// Restore Last Visited location to be more user-friendly
//(function () {
//	const urls = JSON.parse(localStorage.getItem('mxShellModernUILastVisitedUrls') || '{}');
//	const appName = location.href.match(/app-([^/]+)$/)?.[1]; // just for the case when url ends with app name like this "domain.com/app-MyApp/"
//	if (urls.__last__ && ['', '/', '/wm', '/wm/'].includes(location.pathname) && !location.search && !location.hash) {
//		window.location.href = urls.__last__;
//	} else if (appName && urls[appName]) {
//		window.location.href = urls[appName];
//	}
//})();
